import { ZoomImage } from "./zoom-image";
import { ResourceStatus } from "./enums";
import { URLHelper } from "../helpers/url-helper";
import { Loader } from "./loader";
import { ZoomImageTile } from "./zoom-image-tile";

export class ImageManager
{
    public status:ResourceStatus = ResourceStatus.Empty;
    public images:ZoomImage[] = null;
    get length() {return this.images.length;}
    private imageRoot:string = "";

    public imageDefinitionsToLoad:number = 1;
    public imageDefinitionsLoaded:number = 0;

    /**
     * Loads main image database from json. Does not load individual images.
     * @param path URL of the main database file images.json
     */
    public loadDB(url:string)
    {
        this.imageRoot = URLHelper.Absolute(url);
        this.imageRoot = this.imageRoot.substr(0, this.imageRoot.lastIndexOf("/") + 1);
        console.log(`Image root is ${this.imageRoot}`);
        console.log(`Loading image database from ${url}`);

        this.status = ResourceStatus.DefinitionLoading;

        Loader.Load(url, 
            (obj) => 
            {
                if (obj.hasOwnProperty("images"))
                {
                    let images = obj.images;
                    if (Array.isArray(images))
                    {
                        this.images = [];
                        for (let i = 0; i < images.length; i++)
                        {
                            let img = new ZoomImage(this.imageRoot + images[i]);
                            this.images.push(img);
                        }
                        this.loadImageDefinitions();
                        return;
                    }                    
                }
                this.status = ResourceStatus.Error;                                
            }, 
            (code) => 
            {
                console.error(`Image database not loaded. Error ${code}`)
                this.status = ResourceStatus.Error;                                
            }, Loader.TYPE_JSON);
    }    
    
    private loadImageDefinitions()
    {
        this.imageDefinitionsToLoad = this.images.length;
        this.imageDefinitionsLoaded = 0;

        this.each( (img:ZoomImage) => {
            img.loadDefinition();
        });
    }

    public update()
    {
        if (this.status == ResourceStatus.DefinitionLoading && this.images != null)
        {
            let allDefinitionsLoaded:boolean = true;
            this.imageDefinitionsLoaded = 0;    
            this.each( (img) => {

                if (img.status < ResourceStatus.DefinitionLoaded) 
                {
                    allDefinitionsLoaded = false
                }
                else
                {
                    this.imageDefinitionsLoaded++;
                }
            });

            if (allDefinitionsLoaded)
            {
                this.status = ResourceStatus.DefinitionLoaded;
            }
        }
    }

    public preloadImage(im:ZoomImage)
    {
        if (im.status == ResourceStatus.DefinitionLoaded)
        {
            im.preload();
        }
        else
        console.log(`${im.name} not defined`);
    }

    public get(index:number):ZoomImage
    {
        return this.images[index];
    }

    public find(filename:string):ZoomImage
    {
        let result:ZoomImage = null;

        this.each( (img:ZoomImage) => {

            if (img.definition.file == filename)
                result = img;
        });

        return result;        
    }

    public each(callback:(img:ZoomImage) => any)
    {
        for (let i = 0; i < this.images.length; i++)
        {
            callback(this.images[i]);
        }
    }

    public indexOf(img:ZoomImage)
    {
        return this.images.indexOf(img);
    }

    public tileURL(tile:ZoomImageTile):string
    {
        let dot = tile.file.lastIndexOf(".");
        let img = tile.file.substr(0, dot+1) + "tile_" + (tile.index < 10 ? "0" : "") + tile.index + ".jpg";
        return this.imageRoot + "/tiles/" + img;
    }
    
    public allImagesLoaded():boolean
    {
        if (this.images.length == 0) return false;

        let allLoaded = true;
        this.each( (img:ZoomImage) => { 
            if (img.status != ResourceStatus.Loaded) allLoaded = false;
        });
        return false;
    }
}